import React from "react"
import useStyles from "./dropZoneStyles"
import { Container, Typography } from "@material-ui/core"
import { useSelector } from "react-redux"

const SupportedFileList = () => {
	const classes = useStyles()
	const supportedFiles = useSelector((state) => state.upload.supportedFormatsTooltip)

	return (
		<Container className={classes.dropZoneContainer} style={{ maxWidth: 250 }}>
			{Object.keys(supportedFiles).map((category) => (
				<div style={{ marginTop: "5px" }}>
					<Typography variant="body2" component="span" style={{ fontWeight: 500, textTransform: "capitalize" }}>
						{category}:
					</Typography>{" "}
					<Typography variant="body2" component="span" style={{ textTransform: "uppercase" }}>
						{supportedFiles[category].join(", ")}
					</Typography>
				</div>
			))}
		</Container>
	)
}

export default SupportedFileList
